// ----------------------------------------------------------------------
export function drawer(theme) {
    return {
        MuiDrawer: {
            styleOverrides: {
                paper: ({ ownerState }) => ({
                    backgroundColor: theme.palette.common.white92,
                    backdropFilter: 'blur(20px)',
                    WebkitBackdropFilter: 'blur(20px)',
                    // Add subtle border for better definition
                    border: `1px solid ${theme.palette.divider}`,
                    // Ensure proper layering
                    zIndex: theme.zIndex.drawer,
                    // Override default MUI styles that might interfere
                    '&.MuiDrawer-paperAnchorLeft, &.MuiDrawer-paperAnchorRight': {
                        backgroundColor: theme.palette.common.white92,
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)'
                    },
                    '&.MuiDrawer-paperAnchorTop, &.MuiDrawer-paperAnchorBottom': {
                        backgroundColor: theme.palette.common.white,
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)'
                    },
                    // Handle temporary/modal drawers
                    ...(ownerState.variant === 'temporary' && {
                        backgroundColor: theme.palette.common.white92,
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)'
                    }),
                    // Handle persistent drawers
                    ...(ownerState.variant === 'persistent' && {
                        backgroundColor: theme.palette.common.white92,
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)'
                    }),
                    // Handle permanent drawers
                    ...(ownerState.variant === 'permanent' && {
                        backgroundColor: theme.palette.common.white92,
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)'
                    })
                })
            }
        },
        // Override backdrop to ensure proper blur effect visibility
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    // Ensure backdrop doesn't interfere with drawer blur
                    '&.MuiDrawer-backdrop': {
                        backgroundColor: 'rgba(0, 0, 0, 0.3)' // Slightly more transparent to show blur effect
                    }
                }
            }
        }
    };
}
